import { TabBar } from "components/TabBar/TabBar";
import { format } from "date-fns";
import { Filter } from "model/Filter/Filter";
import {
  DataContainer,
  HeaderContainer,
  LogoContainer,
  TabsContainer,
  HeaderDates,
  HeaderDescription,
  HeaderName,
  LinksContainer,
  DateLinksContainer,
  DataLogoContainer,
} from "./styles";
import { Theme } from "model/Theme";
import { TourLogo } from "components/Logo/TourLogo";
import { TournamentLogo } from "components/Logo/TournamentLogo";
import { checkTypeExhausted } from "Utility";
import { Links } from "model/Links";
import { LinkBar } from "components/Links/LinkBar";

type HeaderType = "Tour" | "Tournament";

interface Props {
  endTime: number;
  id: string;
  name: string;
  startTime: number;
  tabFilter: Filter<string>;
  type: HeaderType;
  description?: string;
  links?: Links | undefined;
  theme?: Theme;
}

export const Header = ({
  endTime,
  id,
  name,
  startTime,
  tabFilter,
  type,
  description,
  links,
  theme,
}: Props) => {
  const startDate = format(new Date(startTime), "do MMM");
  const endDate = format(new Date(endTime), "do MMM");
  const endDateYear = format(new Date(endTime), "do MMM yyyy");
  const dateString =
    startDate === endDate ? endDateYear : `${startDate} - ${endDateYear}`;

  return (
    <HeaderContainer>
      <DataLogoContainer>
        <LogoContainer>{getLogo(type, id)}</LogoContainer>
        <DataContainer>
          <HeaderName>{name}</HeaderName>
          <HeaderDescription>{description ?? ""}</HeaderDescription>
          <DateLinksContainer>
            <HeaderDates>{dateString}</HeaderDates>
            {!!links && (
              <LinksContainer>
                <LinkBar links={links} />
              </LinksContainer>
            )}
          </DateLinksContainer>
        </DataContainer>
      </DataLogoContainer>
      <TabsContainer>
        <TabBar
          filter={tabFilter}
          primaryColor={theme?.primary}
          secondaryColor={theme?.secondary}
        />
      </TabsContainer>
    </HeaderContainer>
  );
};

const getLogo = (type: HeaderType, id: string) => {
  switch (type) {
    case "Tour":
      return <TourLogo id={id} />;
    case "Tournament":
      return <TournamentLogo id={id} />;
    default:
      return checkTypeExhausted(type);
  }
};
